export const mcdCategoryId = 'mcd'
